/**
 * Image slider styles for PHI Redaction viewer
 * Defines the styling for the vertical slider component used to navigate through DICOM images
 */

export const getSliderStyles = () => ({
  sliderContainer: {
    position: 'absolute' as const,
    right: '0px',
    top: '0px',
    bottom: '0px',
    width: '18px',
    height: '100%',
    background: 'rgba(255, 255, 255, 0.1)',
    borderRadius: '2px',
    cursor: 'pointer',
    zIndex: 10,
    padding: 0,
    margin: 0,
    border: 'none',
  },
  sliderThumb: {
    position: 'absolute' as const,
    width: '18px',
    height: '60px',
    background: 'linear-gradient(to right, #3a3a3a, #505050, #6a6a6a, #505050, #3a3a3a)',
    borderRadius: '9px',
    border: '1px solid #3a3a3a',
    cursor: 'pointer',
    left: 0,
    top: 0,
    boxSizing: 'border-box' as const,
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.3), inset 1px 0 2px rgba(255, 255, 255, 0.2)',
  },
  gripLine: {
    position: 'absolute' as const,
    width: '70%',
    height: '1.2px',
    background: 'rgba(255, 255, 255, 0.8)',
    left: '15%',
    borderRadius: '1px',
  },
})

/**
 * Calculates grip line positions for the slider thumb
 */
export const getGripLinePositions = () => ({
  first: 'calc(50% - 4px)',
  second: '50%',
  third: 'calc(50% + 4px)',
})
